import { useLanguage } from "../context/LanguageProvider";

export default function CityCard({ city }) {
  const { t } = useLanguage();
  const formatPrice = (price) => {
    return new Intl.NumberFormat("fr", {
      style: "currency",
      currency: "MAD",
    }).format(price)
  }

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    })
  }

  return (
    <div className="group bg-white rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-500 overflow-hidden border border-gray-100 hover:-translate-y-2">
      {/* Header */}
      <div className="px-4 max-md:px-2 py-4 pb-2 bg-white">
        <div className="flex items-center justify-between mb-2">
          <div className="w-10 h-10 max-md:h-9 max-md:w-9 bg-[var(--color-primary-500)] rounded-2xl flex items-center justify-center">
            <svg className="h-6 w-6 max-md:h-5 max-md:w-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
              />
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
            </svg>
          </div>
        </div>
        <h3 className="text-xl max-md:text-md font-bold text-gray-900 group-hover:text-[var(--color-primary-500)] transition-colors duration-300">
          {city.name}
        </h3>

      </div>

      {/* Content */}
      <div className="px-4 max-md:px-2">
        <div className="mb-1">
          <div className="text-xs text-gray-500">{t('cities.shipping_fee')}</div>
          <div className="text-lg font-bold text-green-600">{formatPrice(city.deliver)}</div>
        </div>
      </div>
        <div className="px-4 max-md:px-2 pb-4 grid max-md:grid-cols-2 grid-cols-3 gap-x-3 gap-y-1 ">
          <div>
            <div className="text-xs text-gray-500">{t('cities.return')}</div>
            <div className="text-[11px] font-semibold text-rose-500">{formatPrice(city.return)}</div>
          </div>
          <div>
            <div className="text-xs text-gray-500">{t('cities.refusal')}</div>
            <div className="text-[11px] font-semibold text-yellow-500">{formatPrice(city.refuse)}</div>
          </div>
          <div>
            <div className="text-xs text-gray-500">{t('cities.exchange')}</div>
            <div className="text-[11px] font-semibold text-blue-500">{formatPrice(city.change)}</div>
          </div>
        </div>
    </div>
  )
}
